import { SERVICES } from "@/config";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="border-b border-[#EAEAEA] bg-[#FCFCFC]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-28">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="overline">What I do</div>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight font-medium mt-4 leading-[1.05]">
            Written work, developed to a professional standard.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#EAEAEA] border border-[#EAEAEA]">
          {SERVICES.map((s, i) => (
            <article
              key={i}
              data-testid={`service-${i}`}
              className="bg-white p-8 md:p-12 group transition-colors hover:bg-[#0A192F] hover:text-white"
            >
              <div className="font-display text-sm tabular-nums text-[#4A4A52] group-hover:text-white/60 mb-6">
                {String(i + 1).padStart(2, "0")} / {String(SERVICES.length).padStart(2, "0")}
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight">
                {s.title}
              </h3>
              <p className="mt-5 text-[#4A4A52] group-hover:text-white/80 leading-relaxed max-w-md">
                {s.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
